import QuestionDisclaimer from './questionDisclaimer'

export { QuestionDisclaimer }
